import { IDiemDanhPhongNamHocChangeRequest } from "../../../models/request/diem-danh/IDiemDanhPhongNamHocChangeRequest"
import { IDiemDanhPhongNamHocSelectRequest } from "../../../models/request/diem-danh/IDiemDanhPhongNamHocSelectRequest"
import { DiemDanhResponse } from "../../../models/response/diem-danh/DiemDanhResponse"
import { IActionTypeBase } from "../IActionTypeBase"

export enum eDiemDanhActionTypeIds {

    SELECT_PHONGNAMHOC_START = "DIEMDANH_SELECT_PHONGNAMHOC_START",
    SELECT_PHONGNAMHOC_SUCCESS = "DIEMDANH_SELECT_PHONGNAMHOC_SUCCESS",
    SELECT_PHONGNAMHOC_ERROR = "DIEMDANH_SELECT_PHONGNAMHOC_ERROR",

    CHANGE_DANHSACH_DIEMDANH = "CHANGE_DANHSACH_DIEMDANH",
    SHOW_DIEMDANH_MODAL = "SHOW_DIEMDANH_MODAL",

    DIEMDANH_PHONGNAMHOC_START = "DIEMDANH_LOPCHUNHIEM_START",
    DIEMDANH_PHONGNAMHOC_SUCCESS = "DIEMDANH_LOPCHUNHIEM_SUCCESS",
    DIEMDANH_PHONGNAMHOC_ERROR = "DIEMDANH_LOPCHUNHIEM_ERROR",

    CHANGE_SELECTED_IDS = "DIEMDANH_CHANGE_SELECTED_IDS",
}

export interface IDiemDanhSelectPhongNamHocStart extends IActionTypeBase<eDiemDanhActionTypeIds.SELECT_PHONGNAMHOC_START, IDiemDanhPhongNamHocSelectRequest> { }
export interface IDiemDanhSelectPhongNamHocSuccess extends IActionTypeBase<eDiemDanhActionTypeIds.SELECT_PHONGNAMHOC_SUCCESS, DiemDanhResponse[]> { }
export interface IDiemDanhSelectPhongNamHocErr extends IActionTypeBase<eDiemDanhActionTypeIds.SELECT_PHONGNAMHOC_ERROR, string> { }

export interface IDiemDanhShowModal extends IActionTypeBase<eDiemDanhActionTypeIds.SHOW_DIEMDANH_MODAL, boolean> { }
export interface IDiemDanhChangeDanhSachDiemDanh extends IActionTypeBase<eDiemDanhActionTypeIds.CHANGE_DANHSACH_DIEMDANH, DiemDanhResponse[]> { }

export interface IDiemDanhPhongNamHocStart extends IActionTypeBase<eDiemDanhActionTypeIds.DIEMDANH_PHONGNAMHOC_START, IDiemDanhPhongNamHocChangeRequest> { }
export interface IDiemDanhPhongNamHocSuccess extends IActionTypeBase<eDiemDanhActionTypeIds.DIEMDANH_PHONGNAMHOC_SUCCESS, undefined> { }
export interface IDiemDanhPhongNamHocErr extends IActionTypeBase<eDiemDanhActionTypeIds.DIEMDANH_PHONGNAMHOC_ERROR, string> { }

export interface IDiemDanhChangeSelectedIds extends IActionTypeBase<eDiemDanhActionTypeIds.CHANGE_SELECTED_IDS, number[]> { }

export type IDiemDanhActionTypes = IDiemDanhSelectPhongNamHocStart | IDiemDanhSelectPhongNamHocSuccess | IDiemDanhSelectPhongNamHocErr |
    IDiemDanhShowModal | IDiemDanhChangeDanhSachDiemDanh |
    IDiemDanhPhongNamHocStart | IDiemDanhPhongNamHocSuccess | IDiemDanhPhongNamHocErr | IDiemDanhChangeSelectedIds